import {AfterViewChecked, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {UserResponse} from "../interface/userResponse";
import {UserService} from "../service/user.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Router} from "@angular/router";
import {UserCardService} from "../service/user-card.service";
import {ViewStateService} from "../service/view-state.service";
import {SubscriptionPaymentComponent} from "../subscription-payment/subscription-payment.component";
import {catchError} from "rxjs/operators";
import {MockupDataModel} from "../qr-copy-message/mockup-data.model";
import {CREATE_CARD_LIMIT_ERROR_ALERT} from "../constants/global.constants";
import {TranslateService} from "@ngx-translate/core";
import {of} from "rxjs";
import {SnackBarUtil} from "../qr-copy-message/snack-bar-util.service";
import {MatDialog} from "@angular/material/dialog";

@Component({
  selector: 'app-common',
  templateUrl: './common.component.html',
  styleUrl: './common.component.scss'
})
export class CommonComponent implements AfterViewChecked, OnInit {

  user: UserResponse | any
  userProfileImageUrl: string | any

  hideNavbar: boolean = false;
  isMenuOpened: boolean = false;
  isActiveCancelButton: boolean = false;

  constructor(
    private userService: UserService,
    private snackBar: MatSnackBar,
    private snackBarUtil: SnackBarUtil,
    private router: Router,
    private changeDetector: ChangeDetectorRef,
    private userCardService: UserCardService,
    private viewStateService: ViewStateService,
    private dialog: MatDialog,
    private translateService: TranslateService
  ) {
    const email = this.userService.email;
    this.userService.findByEmail(email).subscribe({
      next: response => {
        this.user = response
        this.userService.setUser(response);
      },
      error: err => {
        if (err.status === 404) {
          this.snackBar.open("User not found");
        }
      },
    })
    this.userService.updatedProfileImageUrl.subscribe((emittedUrl: string | null) => {
      this.userProfileImageUrl = emittedUrl;
    })
  }

  ngOnInit() {
    this.viewStateService.isActiveCancelSubscription$.subscribe(isActiveCancelButton => {
      this.isActiveCancelButton = isActiveCancelButton;
    })
  }

  cancelSubscription() {
    this.viewStateService.setIsCancelSubscription(true);
  }

  get isIndividualCardsPage(): boolean {
    return this.router.url === "/cards";
  }

  get isPlanSubscriptionsPage(): boolean {
    return this.router.url == "/subscriptions";
  }

  get isSubscriptionPaymentPage(): boolean {
    const url = this.router.url;
    return url.includes("/subscriptions/payment");
  }


  onClickPayNowSubscription() {
    SubscriptionPaymentComponent.onClickPayNowFromCommon.next(true);
  }

  openCreateCard() {
    this.userCardService.checkIsUserSubscriptionValidForCreatingCard().pipe(
      catchError(error => {
        if (error.status === 409) {
          this.router.navigate(['/subscriptions'], { state: {isShowAllSubscriptions: true} });
          this.showSnackbar(MockupDataModel.error(this.translateService.instant('user_card.create_card_limit_error')), SnackBarUtil.CLASSES.error)
        }
        return of (false);
      })
    ).subscribe(response => {
      if (response) {
        this.router.navigate(['/create-card']);
      }
    })
  }

  private showSnackbar(data: MockupDataModel, panelClassNames: string[]): void {
    this.snackBarUtil.openSnackBar({
      duration: 3000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: panelClassNames,
      data: data
    });
  }

  ngAfterViewChecked() {
    this.hideNavbar = this.router.url.includes('/profile-page');
    this.changeDetector.detectChanges();
  }
}
